<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          公众号管理
          <span class="titleColor"></span> -模板配置
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 检索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="模版编号">
          <el-input v-model="listQuery.templateId" placeholder="模版编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="模版名称">
          <el-input v-model="listQuery.name" placeholder="模版名称" clearable></el-input>
        </el-form-item>
   

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="el-icon-plus" plan @click="addNewTemplate">新建模版</el-button>
        </el-form-item>
      </el-form>
      <!-- 新增 -->
      <!-- <el-row class="btn-margin">
      
      </el-row>-->
      <!-- 表单 -->
      <el-table :data="listData" border class="table">
        <el-table-column prop="state" label="模板类型">
          <template slot-scope="scope">
            <span v-if="scope.row.templateType==1">公众号模板</span>
            <span v-if="scope.row.templateType==2">普通消息模板</span>
          </template>
        </el-table-column>
        <el-table-column prop="templateId" width="120" label="模版编号" fixed></el-table-column>
        <el-table-column prop="name" label="模版名称"></el-table-column>
        <el-table-column prop="content" label="模版内容" width="280"></el-table-column>
        <el-table-column prop="first" label="第一个参数"></el-table-column>
        <el-table-column prop="keyWord1" label="关键字1"></el-table-column>
        <el-table-column prop="keyWord2" label="关键字2"></el-table-column>
        <el-table-column prop="keyWord3" label="关键字3"></el-table-column>
        <el-table-column prop="keyWord4" label="关键字4"></el-table-column>
        <el-table-column prop="keyWord5" label="关键字5"></el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.deleted==false">启用</span>
            <span v-if="scope.row.deleted==true">停用</span>
          </template>
        </el-table-column>
         <el-table-column prop="remarkWord" label="备注"></el-table-column> 
        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
        <!-- <el-table-column prop="updateTime" label="修改时间" :formatter="dateFormat"></el-table-column> -->
        <el-table-column prop label="操作" fixed="right" width="200">
          <template slot-scope="scope">
          

            <el-button
              type="text"
              class="textWarning"
              v-if="scope.row.deleted == false"
              @click="stopBtn(scope.$index,scope.row)"
            >停用</el-button>
            <el-button
              type="text"
              v-if="scope.row.deleted == true"
              @click="openBtn(scope.$index,scope.row)"
            >启用</el-button>
             <el-button
              type="text"
              v-if="scope.row.deleted == true"
              @click="editBtn(scope.row)"
            >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />

      <!-- 新增消息 -->
      <el-dialog title="新增模版消息" :visible.sync="addVisible" width="620px" center>
        <el-form
          ref="addTemplateForm"
          :rules="rules"
          :model="addTemplateForm"
          label-width="120px"
        >
        <el-form-item label="模版类型" prop="templateType">
           <el-select v-model="addTemplateForm.templateType" clearable placeholder="请选择跟单类型" filterable>
              <el-option v-for="(item,index) in templateTypeMap" :key="index" :label="item"
                        :value="index">
              </el-option>
            </el-select>
            <span>公众号模板需要填写模板id</span>
        </el-form-item>

          <el-form-item label="模版id" prop="templateId">
            <el-input v-model="addTemplateForm.templateId" placeholder  clearable></el-input>
          </el-form-item>
             <el-form-item label="模版标题" prop="name">
            <el-input v-model="addTemplateForm.name" placeholder  clearable></el-input>
          </el-form-item>
         

          <el-form-item label="模版内容" prop="content">
            <el-input
              type="textarea"
              v-model="addTemplateForm.content"
              :rows="8"
              placeholder="请输入内容"
              class="input-width"
            ></el-input>
          </el-form-item>
          <el-form-item label="固定参数">
            <el-tag style="cursor:pointer"   v-for="(item,index) in defaultFieldList" :key="index" @click="setKeyField(item.field)">
              {{ item.fieldName }} 
            </el-tag> 
            
          </el-form-item>
          <el-form-item label="第一个参数" prop="first">
            <el-input v-model="addTemplateForm.first"  @focus="focusKey=0"  placeholder  clearable></el-input>
          </el-form-item>
           <el-form-item label="关键字1" prop="keyWord1">
            <el-input v-model="addTemplateForm.keyWord1"  @focus="focusKey=1"  placeholder  clearable></el-input>
          </el-form-item>
           <el-form-item label="关键字2" prop="keyWord2">
            <el-input v-model="addTemplateForm.keyWord2"  @focus="focusKey=2"  placeholder  clearable></el-input>
          </el-form-item>
          <el-form-item label="关键字3" prop="keyWord3">
            <el-input v-model="addTemplateForm.keyWord3"  @focus="focusKey=3"  placeholder  clearable></el-input>
          </el-form-item>
          <el-form-item label="关键字4" prop="keyWord4">
            <el-input v-model="addTemplateForm.keyWord4"  @focus="focusKey=4"  placeholder  clearable></el-input>
          </el-form-item>
           <el-form-item label="关键字5" prop="keyWord5">
            <el-input v-model="addTemplateForm.keyWord5"  @focus="focusKey=5"  placeholder  clearable></el-input>
          </el-form-item>
          <el-form-item label="remark参数" prop="remarkWord">
            <el-input v-model="addTemplateForm.remarkWord"  @focus="focusKey=6"  placeholder  clearable></el-input>
          </el-form-item>
           <p>关键字和参数需要和模板参数顺序对应，可点击上面固定参数填充，或手动输入</p>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddTemplateForm('addTemplateForm')">取 消</el-button>
          <el-button type="primary" plan @click="confAddTemplateForm('addTemplateForm')">确 定</el-button>
        </span>
      </el-dialog>


      <!-- 编辑消息 -->
      <el-dialog title="编辑模版消息" :visible.sync="editVisible" width="620px" center>
        <el-form
          ref="editTemplateForm"
          :rules="editRules"
          :model="editTemplateForm"
          label-width="120px"
        >
        <el-form-item label="模版类型" prop="templateType">
           <el-select disabled v-model="editTemplateForm.templateType"   placeholder="请选择跟单类型" filterable>
              <el-option v-for="(item,index) in templateTypeMap" :key="index" :label="item"
                        :value="index">
              </el-option>
            </el-select>
        </el-form-item>
          <el-form-item label="模版id" prop="templateId">
            <el-input v-model="editTemplateForm.templateId" placeholder  clearable disabled></el-input>
          </el-form-item>
             <el-form-item label="模版标题" prop="name">
            <el-input v-model="editTemplateForm.name" placeholder  clearable></el-input>
          </el-form-item>
       

          <el-form-item label="模版内容" prop="content">
            <el-input
              type="textarea"
              v-model="editTemplateForm.content"
              :rows="8"
              placeholder="请输入内容"
              class="input-width"
            ></el-input>
          </el-form-item>
                 <el-form-item label="固定参数">
            <el-tag style="cursor:pointer"   v-for="(item,index) in defaultFieldList" :key="index" @click="setKeyFieldEdit(item.field)">
              {{ item.fieldName }} 
            </el-tag>
             </el-form-item>
              <el-form-item label="第一个参数" prop="first">
            <el-input v-model="editTemplateForm.first" @focus="focusKeyEdit=0" placeholder  clearable></el-input>
          </el-form-item>
         
           <el-form-item label="关键字1" prop="keyWord1">
            <el-input v-model="editTemplateForm.keyWord1"  @focus="focusKeyEdit=1" placeholder  clearable></el-input>
          </el-form-item>
           <el-form-item label="关键字2" prop="keyWord2">
            <el-input v-model="editTemplateForm.keyWord2" @focus="focusKeyEdit=2" placeholder  clearable></el-input>
          </el-form-item>
          <el-form-item label="关键字3" prop="keyWord3">
            <el-input v-model="editTemplateForm.keyWord3" @focus="focusKeyEdit=3" placeholder  clearable></el-input>
          </el-form-item>
          <el-form-item label="关键字4" prop="keyWord4">
            <el-input v-model="editTemplateForm.keyWord4" @focus="focusKeyEdit=4" placeholder  clearable></el-input>
          </el-form-item>
           <el-form-item label="关键字5" prop="keyWord5">
            <el-input v-model="editTemplateForm.keyWord5" @focus="focusKeyEdit=5" placeholder  clearable></el-input>
          </el-form-item>
           <el-form-item label="remark参数" prop="remarkWord">
            <el-input v-model="editTemplateForm.remarkWord"  @focus="focusKeyEdit=6"  placeholder  clearable></el-input>
          </el-form-item>
          <p>关键字和参数需要和模板参数顺序对应，可点击上面固定参数填充，或手动输入</p>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible=false">取 消</el-button>
          <el-button type="primary" plan @click="confEditTemplateForm('editTemplateForm')">确 定</el-button>
        </span>
      </el-dialog>
    
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data";
import service from "@/script/api/service";
export default {
  components: { Pagination },
  data() {
    return {
      templateTypeMap:{1:'公众号模板',2:'普通消息模板'},
      focusKey:0,//0 first 到 6 remark_word
      focusKeyEdit:0,
      defaultFieldList:[],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      listData: [],
      listQuery: {
        templateId: "",
        name: "",
      },
       addVisible: false,
       editVisible: false,
       addTemplateForm:{
        templateType:'',
         templateId:'',
         name:'',
         first:'',
         content:'',
         keyWord1:'',
         keyWord2:'',
         keyWord3:'',
         keyWord4:'',
         keyWord5:'',
         remarkWord:''
       },
       editTemplateForm:{
        templateType:'',
         templateId:'',
         name:'',
         first:'',
         content:'',
         keyWord1:'',
         keyWord2:'',
         keyWord3:'',
         keyWord4:'',
         keyWord5:'',
         remarkWord:'',
       },
      rules: {
        templateType: [
          { required: true, message: "请选择目标类型", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入模版标题", trigger: "change" }
        ],
        content: [
          { required: true, message: "请输入模版内容", trigger: "change" }
        ],
       
      },
      editRules: {
        templateType: [
          { required: true, message: "请选择目标类型", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入模版标题", trigger: "change" }
        ],
        content: [
          { required: true, message: "请输入模版内容", trigger: "change" }
        ],
       
      },




      
    };
  },
  created() {
    this.querySearch();
  },
  methods: {
    setKeyField(val){
      // focusKey:0,//0 first 到 6 remark_word
      // defaultFieldList:[],
       switch (this.focusKey) {
          case 0: this.addTemplateForm.first=val;
          break;
          case 1: this.addTemplateForm.keyWord1=val;
          break;
          case 2:  this.addTemplateForm.keyWord2=val;
          break;
          case 3:  this.addTemplateForm.keyWord3=val;
          break;
          case 4:  this.addTemplateForm.keyWord4=val;
          break;
          case 5:  this.addTemplateForm.keyWord5=val;
          break;
          case 6:  this.addTemplateForm.remarkWord=val;
          break; 
        default:
        this.$message.warning('未关联输入框，请点击输入框后再操作');
          break;
       }
    },
    setKeyFieldEdit(val){
      // focusKey:0,//0 first 到 6 remark_word
      // defaultFieldList:[],
       switch (this.focusKeyEdit) {
          case 0: this.editTemplateForm.first=val;
          break;
          case 1: this.editTemplateForm.keyWord1=val;
          break;
          case 2:  this.editTemplateForm.keyWord2=val;
          break;
          case 3:  this.editTemplateForm.keyWord3=val;
          break;
          case 4:  this.editTemplateForm.keyWord4=val;
          break;
          case 5:  this.editTemplateForm.keyWord5=val;
          break;
          case 6:   this.editTemplateForm.remarkWord=val;
          break; 
        default:
        this.$message.warning('未关联输入框，请点击输入框后再操作');
          break;
       }
    },
    //查询
    querySearch() {
      service
        .$axioWxMpTemplateList({
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          templateId:this.listQuery.templateId,
          name:this.listQuery.name
        })
        .then(res => {
          console.log(res);
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //取消新增并重置
    cancelAddTemplateForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.addVisible = false;
    },
    //确定新增
    confAddTemplateForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.addTemplateForm;
        

          service.$axioWxAddTempLate(params).then(res => {
            console.log(res);
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.addVisible = false;
              this.querySearch();
            } else {
              this.$message.warning(res.data.data);
            }
          });
        } else {
          console.log("err");
        }
      });
    },
    //新增消息模版
    addNewTemplate() {
      this.addVisible = true;
      this.addTemplateForm={
        templateType:'',
         templateId:'',
         name:'',
         first:'',
         content:'',
         keyWord1:'',
         keyWord2:'',
         keyWord3:'',
         keyWord4:'',
         keyWord5:'',
         remarkWord:'',
       };

       service.$axioWxMpGetDefaultField().then(res=>{
        this.defaultFieldList=res.data.data;
       })
    },
    editBtn(row) {
      this.editVisible = true;
      this.editTemplateForm=row;
       service.$axioWxMpGetDefaultField().then(res=>{
        this.defaultFieldList=res.data.data;
       })
    },
    confEditTemplateForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.editTemplateForm;
        

          service.$axioWxEditTempLate(params).then(res => {
            console.log(res);
            if (res.data.errno == 0) {
              this.$message.success("编辑成功");
              this.editVisible = false;
              this.querySearch();
            } else {
              this.$message.warning(res.data.data);
            }
          });
        } else {
          console.log("err");
        }
      });
    },
     //停用确认框
    stopBtn(index, row) {
      this.$confirm("您确定停用吗？")
        .then(_ => {
          this.confStop(row.id);
        })
        .catch(_ => {});
    },
    //启用确认框
    openBtn(index, row) {
      this.$confirm("您确定启用吗？")
        .then(_ => {
          this.confOpen(row.id);
        })
        .catch(_ => {});
    },
    confOpen(id) {
      service
        .$axioWxMpTemplateDel({
          id: id,
          deleted:false
        })
        .then(res => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.querySearch();
          } else {
            this.$message.warning(res.data.errmsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    confStop(id) {
      service
        .$axioWxMpTemplateDel({
          id: id,
         deleted:true
        })
        .then(res => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.querySearch();
          } else {
            this.$message.warning(res.data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined||date =='') {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    },





  }
};
</script>
<style scoped>
 .el-form{
    padding:0 60px 0 20px!important;
  }
  .el-tag--small{
    margin-right:8px;
  }
</style>

